import {Stack} from '@mantine/core';
import {BasicPage} from '../../components/basic-page';
import {JobArchiveDocumentsListing} from '../documents/job-document-listing';
import {JobPartKitLotNumber} from './job-archive-part-kit-lot-number';
import {JobArchiveReplacedParts} from './job-archive-replaced-parts';
import {JobArchiveStatus} from './job-archive-status';

type JobArchiveProps = {
  children?: React.ReactNode;
};

export const JobArchive: React.FC<JobArchiveProps> = () => {
  return (
    <BasicPage p={0} pb={32} maxWidth='97%'>
      <Stack>
        <JobArchiveStatus />
        <JobPartKitLotNumber />
        <JobArchiveReplacedParts />
        <JobArchiveDocumentsListing />
      </Stack>
    </BasicPage>
  );
};
